import { CampaignsTable } from './components/CampaignsTable';

export function CampaignsPage() {
  return <CampaignsTable />;
}
